import { DeviceExperience } from '../models/ui/DeviceExperience';

export const DeviceStore = {
  get deviceExperience(): DeviceExperience | null {
    const lsValue = localStorage.getItem(
      'deviceExperience',
    ) as DeviceExperience;
    return NullOrEmpty(lsValue) ? null : lsValue;
  },
  set deviceExperience(value: DeviceExperience | null) {
    localStorage.setItem('deviceExperience', value?.toString() ?? null);
  },
};

export function LogoutFromIdp() {
  return DeviceStore.deviceExperience != DeviceExperience.Personal;
}

function NullOrEmpty(value: string) {
  return value == null || value == undefined || value == '';
}
